import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Loader from '../../components/Loader';
import { ROUTES } from '../../constants/routes';
import { setIsAuthenticated } from '../../redux/auth.slice';
import { googleLogin } from '../../services/AuthService';

const Callback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const location = useLocation();

    useEffect(() => {
        const mCode = new URLSearchParams(location?.search).get('code');

        if (mCode) {
            googleLogin({ code: mCode })
                .then((response: any) => {
                    if (response?.token) {
                        dispatch(setIsAuthenticated(true));
                        navigate(ROUTES.HOME);
                    } else {
                        navigate(ROUTES.LOGIN, {
                            replace: true,
                            state: { error: t('Auth.Error.Login_Failed') },
                        });
                    }
                })
                .catch((error: any): any => {
                    navigate(ROUTES.LOGIN, {
                        replace: true,
                        state: {
                            error: error?.response?.data?.message || t('Auth.Error.Google_Auth_Error'),
                        },
                    });
                });
        }
    }, []);

    return <Loader />;
};

export default Callback;
